import { AdtLeadTimesActions, AdtLeadTimesActionTypes } from '../../actions/lead-times.actions';
import { LeadTimePerRegions } from '../../../models/lead-time.interface';

/**
 * LeadTimes state
 */
export interface LeadTimesState {
  loading: boolean;
  leadTimes: LeadTimePerRegions[];
}

/**
 * Initial state of leadTimes
 */
export const initialState: LeadTimesState = {
  loading: false,
  leadTimes: undefined,
};

/**
 * LeadTimes reducer
 * @param {LeadTimesState} state Lead times state
 * @param {AdtLeadTimesActions} action lead times actions
 * @returns {LeadTimesState}
 */
export function adtLeadTimesReducer(state = initialState, action: AdtLeadTimesActions): LeadTimesState {
  switch (action.type) {
    case AdtLeadTimesActionTypes.FETCH_LEAD_TIMES:
      return {
        ...state,
        loading: true,
      } as LeadTimesState;
    case AdtLeadTimesActionTypes.FETCH_LEAD_TIMES_SUCCESS:
      return {
        ...state,
        leadTimes: action.payload,
        loading: false,
      } as LeadTimesState;
    case AdtLeadTimesActionTypes.FETCH_LEAD_TIMES_FAILURE:
      return {
        ...state,
        loading: false,
      } as LeadTimesState;
    case AdtLeadTimesActionTypes.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
